import { useEffect, useState } from "react";
import { IUserData } from "../../interfaces/userData.interface";
import { SelectWrapper } from "./Ui/SelectWrapper";
import { getUsersBySearch, getUsersByUuid } from "../../utils/User";
import { useAppSelector } from "../../store";
import { toast } from "react-toastify";
import { userTypeEnum } from "../FlightEnquiryForm/CreateNewAgent";

export interface ISelectedCustomer {
  label: string;
  value: string;
  phone: string;
  name: string;
  user: IUserData;
}

export const SearchCustomerSelect: React.FC<{
  onChange: (selectedCustomer: ISelectedCustomer) => void;
  value: string | undefined;
  isDisabled?: boolean;
  isLoading?: boolean;
  userType?: userTypeEnum;
}> = (props) => {
  const userData = useAppSelector((state) => state.users.userData);
  const [searchedUser, setSearchedUserData] = useState<IUserData[]>([]);
  const [inputChange, setInputChange] = useState<string>("");
  const [searchUserDataLoading, setSearchUserDataLoading] = useState(false);

  const getUserBySearch = async () => {
    try {
      setSearchUserDataLoading(true);
      const searchUserRes = await getUsersBySearch(inputChange, props.userType);
      if (searchUserRes.success) {
        setSearchedUserData(searchUserRes.result);
      }
    } catch (error) {
      toast.error("Something went wrong, try again later!!");
    }
    setSearchUserDataLoading(false);
  };

  useEffect(() => {
    if (inputChange.trim().length && userData?.userType === "staff") {
      getUserBySearch();
    }
  }, [inputChange, userData]);

  useEffect(() => {
    const isAlreadyExists = searchedUser.find((user) => {
      return user.uuid === props.value;
    });
    if (props.value && !isAlreadyExists) {
      setSearchUserDataLoading(true);
      getUsersByUuid([props.value])
        .then((res) => {
          if (res.success) {
            setSearchedUserData(res.result);
          }
        })
        .catch((err: any) => {})
        .finally(() => {
          setSearchUserDataLoading(false);
        });
    }
  }, [props.value]);

  return (
    <SelectWrapper
      options={searchedUser?.map((e: IUserData) => {
        const phoneCode = parseInt(e.phoneCode) ? e.phoneCode : "";
        return {
          label: `${e.firstName} ${e.lastName}(${e.email}) ${phoneCode} ${
            e.phone || ""
          }`,
          value: `${e.uuid}`,
          phone: phoneCode + " " + e.phone,
          name: `${e.firstName} ${e.lastName}`,
          user: e,
        };
      })}
      onChange={props.onChange}
      onInputChange={(e) => {
        setInputChange(e);
      }}
      value={props.value}
      isLoading={props.isLoading || searchUserDataLoading}
      isDisabled={props.isDisabled}
    />
  );
};
